function matchApplicableObjects(applicableObjects) {
  const applicableObjectsMap = {
    0: '企业',
    1: '个人'
  }
  return (
    applicableObjects
      .split(',')
      .map(item => applicableObjectsMap[item])
      .join('、') || '-'
  )
}

const loanStatusMap = new Map()
  .set(0, '待分发')
  .set(1, '已分发')
  .set(2, '已授信')
  .set(3, '已拒单')
  .set(8, '撤回')
  .set(9, '撤回')
  .set(10, '撤回待审核')
  .set(11, '草稿')

export const ReviewStatusColorMap = {
  待审核: '#FF8F1F',
  通过: '#00B578',
  驳回: '#F05D4F',
  退回补充资料: '#FF8F1F',
  undefined: '#999'
}

export { matchApplicableObjects, loanStatusMap }
